import { useQuery } from "@tanstack/react-query";
import {
  fetchUserFolders,
  fetchUserSubfolders,
  fetchUserFiles,
  fetchAllUserFiles,
} from "../services/fetchUserFileHierarchy";

/**
 * Hook to fetch top-level folders.
 */
export function useUserFolders() {
  return useQuery({
    queryKey: ["userFolders"],
    queryFn: fetchUserFolders,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to fetch subfolders for a given folderId.
 * @param {string} folderId
 */
export function useUserSubfolders(folderId) {
  return useQuery({
    queryKey: ["userSubfolders", folderId],
    queryFn: () => fetchUserSubfolders(folderId),
    enabled: !!folderId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to fetch files for a given folderId and subfolderId.
 * @param {string} folderId
 * @param {string} subfolderId
 */
export function useUserFiles(folderId, subfolderId) {
  return useQuery({
    queryKey: ["userFiles", folderId, subfolderId],
    queryFn: () => fetchUserFiles(folderId, subfolderId),
    enabled: !!folderId && !!subfolderId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to fetch all files across all folders and subfolders.
 */
export function useAllUserFiles() {
  return useQuery({
    queryKey: ["allUserFiles"],
    queryFn: fetchAllUserFiles,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
